export default {
  // フッター
  TERMS_OF_SERVICE: "使用条款",
  PRIVACY_POLICY: "隐私政策",
  COMPANY_INFORMATION: "企业信息",
  MAILORDERLAW_DETAILS: "根据特定商业交易法的显示根据特定商业交易法的显示",
  ATAMI_CITY_TOURISM_ASSOCIATION: "热海市旅游协会 (Atami City Tourism Association)",
};
